import { IState } from '../../store';

export const selectIsBrokerAvailable = (state: IState) => {
  return (
    state.offerData.newbuildingBroker?.partnerRewardsRegistrationStatus === 'connected' ||
    state.offerData.newbuildingBroker?.partnerRewardsRegistrationStatus === 'inProgress'
  );
};
